import { displayToast, sendAppsignalError } from "../modules/utils";

class ShopSearchFilter {
  constructor(node) {
    this.element = node;
    this.searchInput = this.element.querySelector(".js-shop-search-filter-input");
    this.contentWrapper = document.querySelector(".js-shop-search-filter-content");
    this.subCategoryFilterInput = this.element.querySelector(".js-shop-filter-sub-category-input");

    this.fetchUrl = new URL(this.element.action);
    this.url = new URL(window.location);
    this.formData = new URLSearchParams(window.location.search);

    this.initialize();
  }

  initialize() {
    if (this.subCategoryFilterInput) {
      this.subCategoryFilterInput.addEventListener("change", () => {
        this.updateHistory();
        this.fetchResults();
      });
    }

    window.addEventListener("bundle-added", () => {
      this.updateHistory();
      this.fetchResults();
    });

    this.searchInput.addEventListener("change", () => {
      this.updateHistory();
      this.fetchResults();
    });

    window.addEventListener("popstate", (event) => {
      const currentUrl = new URL(event.target.location.href);
      const { searchParams } = currentUrl;

      for (const [key, value] of searchParams) {
        this.fetchUrl.searchParams.set(key, value);

        if (!this.selectInstance) return;

        this.selectInstance.inputElement.value = value;
        this.selectInstance.dropdownElement.querySelector(`label[for="${value}"]`)?.click();

        if (this.selectInstance.dropdownVisible) {
          this.selectInstance.toggleDropdown();
        }
      }
    });

    window.addEventListener("beyuna-classes-initialized", () => {
      this.selectInstance = window.Beyuna.objects["custom-select"]["shop-filter"];
    });

    this.updateHistory();
    this.fetchResults();
  }

  updateHistory() {
    this.formData = new FormData(this.element);

    for (const [key, value] of this.formData.entries()) {
      this.url.searchParams.set(key, value);
      this.fetchUrl.searchParams.set(key, value);
    }

    if (this.url.href != new URL(window.location).href) {
      window.history.pushState({}, "", this.url);
    }
  }

  fetchResults() {
    this.contentWrapper.classList.add("is-loading");

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        const { contentEntries } = data;

        this.contentWrapper.innerHTML = contentEntries;

        window.Beyuna.initClasses(this.contentWrapper);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "ShopFilter", {
          response: this.response,
        });
      })
      .finally(() => {
        this.contentWrapper.classList.remove("is-loading");
      });
  }
}

const shopFilterWrapper = document.querySelector("[data-js='shop-search-filter']");

if (shopFilterWrapper) {
  new ShopSearchFilter(shopFilterWrapper);
}
